import instance from "./Instance/index.js";

export const addFriend = async (id, values) => {
  try {
    const response = await instance.post(`/friends/${id}`, values);
    return response;
  } catch (err) {
    throw err;
  }
};

export const getFriends = async (id) => {
  try {
    const response = await instance.get(`/friends/${id}`);
    return response;
  } catch (err) {
    throw err;
  }
};

export const checkFriends = async (id, values) => {
  try {
    const response = await instance.post(`/friends/check/${id}`, values);
    return response;
  } catch (err) {
    throw err;
  }
};

export const deleteFriend = async (values) => {
  try {
    const response = await instance.delete(`/friends/delete`, {data: values});
    return response;
  } catch (err) {
    throw err;
  }
};
